;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:cacheKey\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"cacheKey\"],\"hasOptionalPrefix\":false},{\"path\":\"/:cacheKey/:slugs*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"cacheKey\",\"slugs\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"}]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';

const {
    sharedSentryReplayIntegrationConfig,
} = require('../../libs/common-next/shared-sentry.replayIntegration.config');

const { initSentryClient } = require('../../libs/common-next/shared-sentry.client.config');

initSentryClient({
    createAppOptions: () => ({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

        initialScope: {
            tags: {
                application_name: 'PDP',
            },
        },

        // PDP-specific override: use _PDP version if available, otherwise fall back to shared
        // sampleRate controls what % of error events are sent to Sentry
        sampleRate:
            Number(process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE_PDP) ||
            Number(process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE) ||
            0.1,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate:
            Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE_PDP) ||
            Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE) ||
            0.05,

        replaysSessionSampleRate:
            Number(process.env.NEXT_PUBLIC_REPLAYS_SESSION_SAMPLE_RATE_PDP) ||
            Number(process.env.NEXT_PUBLIC_REPLAYS_SESSION_SAMPLE_RATE) ||
            0,

        replaysOnErrorSampleRate:
            Number(process.env.NEXT_PUBLIC_REPLAYS_ON_ERROR_SAMPLE_RATE_PDP) ||
            Number(process.env.NEXT_PUBLIC_REPLAYS_ON_ERROR_SAMPLE_RATE) ||
            0.065,

        // NOTE: The BrowserTracing and Replay was commented out to avoid performance issue
        integrations: [
            Sentry.captureConsoleIntegration({
                levels: ['error'],
            }),
            Sentry.replayIntegration(sharedSentryReplayIntegrationConfig),
            Sentry.httpClientIntegration(),
        ],

        sendDefaultPii: true,
    }),
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

export default Sentry;
